// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";
// import en from "./locales/en.json"
// import he from "./locales/he.json";

// i18n
//   .use(initReactI18next)
//   .init({
//     resources: {
//       en: { translation: en },
//       he: { translation: he },
//     },
//     lng: "en",
//     fallbackLng: "en",
//     interpolation: { escapeValue: false },
//   });

// export default i18n;

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import he from "./locales/he.json";

const storedLanguage = localStorage.getItem("language") || "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      he: { translation: he },
    },
    lng: storedLanguage, 
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
